import { ta } from '@/config/tracking';

export const track = (eventName: string, properties?: Record<string, any>) => {
  ta.track(eventName, properties || {});
};

export const taLogout = () => {
  ta.logout();
};

export const taAutoTrackSinglePage = () => {
  ta.autoTrackSinglePage();
};

export const taTrackLink = (element: any, eventName: string, properties: any) => {
  ta.trackLink(element, eventName, properties);
};